export const liturgiesSelector = state => state.liturgies.list;
export const liturgiesCountSelector = state => state.liturgies.count;
export const liturgySelector = state => state.liturgies.liturgy;
export const liturgyBookingsSelector = state => state.liturgies.bookings;
